"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMedia = SocialMedia;
exports.SocialMediaContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
const SocialMediaContainer = exports.SocialMediaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SocialMediaContainer",
  class: "pl-s1aesdsg"
});

/**
 * Social Media Menu component.
 *
 * @param {Object} props React props
 * @param {node} props.children children
 * @returns {React.ReactElement} Social Media layout
 * @public
 */
function SocialMedia({
  children
}) {
  return /*#__PURE__*/_react.default.createElement(SocialMediaContainer, {
    "data-cy": "social-media"
  }, children);
}
SocialMedia.propTypes = {
  children: _propTypes.default.node
};